import axiosInstance from "./axiosConfig";

const wishlistService = {
  // Get user's wishlist
  getWishlist: async () => {
    try {
      const response = await axiosInstance.get("/wishlist");
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Add product to wishlist
  addToWishlist: async (productData) => {
    try {
      const response = await axiosInstance.post("/wishlist", productData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Remove from wishlist by ID
  removeFromWishlist: async (id) => {
    try {
      const response = await axiosInstance.delete(`/wishlist/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Remove from wishlist by product ID
  removeByProductId: async (productId) => {
    try {
      const response = await axiosInstance.delete(
        `/wishlist/product/${productId}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Clear entire wishlist
  clearWishlist: async () => {
    try {
      const response = await axiosInstance.delete("/wishlist");
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Toggle notify on stock
  toggleNotify: async (id) => {
    try {
      const response = await axiosInstance.patch(`/wishlist/${id}/notify`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Check if product is in wishlist
  checkWishlist: async (productId) => {
    try {
      const response = await axiosInstance.get(`/wishlist/check/${productId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Move to cart
  moveToCart: async (id, quantity = 1) => {
    try {
      const response = await axiosInstance.post(
        `/wishlist/${id}/move-to-cart`,
        {
          quantity,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default wishlistService;
